import React, { useState, useEffect } from 'react';
import { FaCheckCircle } from 'react-icons/fa';

function InvitePlayerModal({ onClose, onSubmit, inviteCode, onCopyInviteLink, playerAdded }) {
    const [step, setStep] = useState(1); // Step 1: Collect info, Step 2: Show invite code
    const [inviteForm, setInviteForm] = useState({
        first_name: '',
        last_name: '',
        phone: '',
        email: ''
    });
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!inviteForm.first_name || !inviteForm.last_name || !inviteForm.phone) {
            setError('Please fill in all required fields');
            return;
        }

        // Move to step 2 after collecting minimal information
        setStep(2);
        
        // Submit the form data to the parent component
        onSubmit(inviteForm);
    };

    return (
        <div className="modal-overlay">
            <div className="modal">
                <button 
                    className="modal-close"
                    onClick={onClose}
                >
                    ×
                </button>
                <h2>Add Player</h2>
                
                {step === 1 ? (
                    // Step 1: Collect minimal player information
                    <>
                        <p className="modal-description">
                            Enter player details to add them to your team. They will be able to complete their profile after joining.
                        </p>
                        {error && <div className="error-message">{error}</div>}
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>First Name *</label>
                                <input
                                    type="text"
                                    value={inviteForm.first_name}
                                    onChange={(e) => setInviteForm({
                                        ...inviteForm,
                                        first_name: e.target.value
                                    })}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Last Name *</label>
                                <input
                                    type="text"
                                    value={inviteForm.last_name}
                                    onChange={(e) => setInviteForm({
                                        ...inviteForm,
                                        last_name: e.target.value
                                    })}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Phone *</label>
                                <input
                                    type="tel"
                                    value={inviteForm.phone}
                                    onChange={(e) => setInviteForm({
                                        ...inviteForm,
                                        phone: e.target.value.replace(/\D/g, '').slice(0, 15)
                                    })}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Email (optional)</label>
                                <input
                                    type="email"
                                    value={inviteForm.email}
                                    onChange={(e) => setInviteForm({
                                        ...inviteForm,
                                        email: e.target.value
                                    })}
                                />
                            </div>
                            <div className="modal-buttons">
                                <button type="submit">Continue</button>
                            </div>
                        </form>
                    </>
                ) : (
                    // Step 2: Show success message and invite code
                    <>
                        {playerAdded && (
                            <div className="success-message player-added-success">
                                <div className="success-icon">
                                    <FaCheckCircle size={32} />
                                </div>
                                <div className="success-content">
                                    <h3>Player Added Successfully!</h3>
                                    <p>
                                        <strong>{playerAdded.name}</strong> has been added to your team and an invitation SMS has been sent. 
                                        You can now assign them to your matches.
                                    </p>
                                </div>
                            </div>
                        )}
                        
                        <div className="invite-code-section">
                            <p>You can also copy the invite link below if needed:</p>
                            <div className="invite-code">
                                <p><strong>Player Code</strong>:&nbsp;<span>{inviteCode}</span></p>
                                {playerAdded && playerAdded.id && (
                                    <p><strong>Full Invite Code</strong>:&nbsp;<span>{inviteCode}-{playerAdded.id}</span></p>
                                )}
                                <button onClick={onCopyInviteLink}>Copy Invite Link</button>
                            </div>
                            <p className="profile-completion-note">
                                <strong>Important:</strong> Share this link with the player so they can complete their profile stats and preferences.
                            </p>
                        </div>
                        
                        <div className="modal-buttons">
                            <button onClick={onClose}>Done</button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default InvitePlayerModal; 